/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AuthorizeDigitalWalletPaymentRequest} from '@cash-web/protos/squareup/cash/cashlynxflow/api/v2/authorize_digital_wallet_payment.pb'
import {AuthorizeDigitalWalletPaymentResponse} from '@cash-web/protos/squareup/cash/cashlynxflow/api/v2/authorize_digital_wallet_payment.pb'


export const authorizeDigitalWalletPayment = (request:AuthorizeDigitalWalletPaymentRequest, options?: CashRequestOptions) => post<AuthorizeDigitalWalletPaymentRequest, AuthorizeDigitalWalletPaymentResponse>("/2.0/cash/authorize-digital-wallet-payment", request, {...options, rejectOnError: true })